import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import * as _ from 'underscore';
import { timeStamp } from 'console';

export interface PlatformNetwork {
	platformName: string;
	logoPath: string;
	impressions: number;
	percent25: any;
	value25: number;
	percent50: any;
	value50: number;
	percent75: any;
	value75: number;
	percent100: any;
	value100: number;
}

@Component({
	selector: 'app-r10-platform-performance',
	templateUrl: './r10-platform-performance.component.html',
	styleUrls: ['./r10-platform-performance.component.css']
})
export class R10PlatformPerformanceComponent extends BaseWidgetComponent implements OnInit {
	@Input() sectionclass: string;
	@Input() iscustomendpoint: any;
	public platformNetworks: any;
	public pageId: any;

	constructor(protected analyticsService: AnalyticsService) {
		super(analyticsService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.requestData();
			this.pageId = 1;
		});
	}

	ngOnInit(): void {
		super.ngOnInit();
	}

	requestData(): void {
		this.showLoad = true;
		this.hasData = false;
		this.platformNetworks = [];
		if (this.iscustomendpoint == 'true') {
			this.analyticsService.processCustomServiceRequest(this.key).subscribe((response: any) => {
				this.showLoad = false;
				if (response.success && response.data.length > 0) {
					this.hasData = true;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
				}
			});
		} else {
			this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
				this.showLoad = false;
				if (response.success && response.data.length > 0) {
					this.hasData = true;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
				}
			});
		}
	}
	processResponseData(response: any): void {
		this.platformNetworks = this.mapPlatformResponseToInterface(response);
		this.platformNetworks = _.sortBy(
			_.sortBy(this.platformNetworks, (platform: any) => {
				return platform.platformName;
			}).reverse(),
			(platform: any) => {
				return Number(platform.impressions);
			}
		).reverse();
	}

	mapPlatformResponseToInterface(responseArray: any[]): PlatformNetwork[] {
		const platformNetworks: PlatformNetwork[] = [];
		for (const responseObj of responseArray) {
			const platformNetwork: PlatformNetwork = {} as PlatformNetwork;
			platformNetwork.platformName = !UtilityService.isUndefinedOrNull(responseObj.platform_name)
				? responseObj.platform_name
				: responseObj.name;
			platformNetwork.logoPath = responseObj.logo_path;
			platformNetwork.impressions = !UtilityService.isUndefinedOrNull(responseObj.impressions)
				? parseInt(responseObj.impressions, 10)
				: 0;
			platformNetwork.percent25 = !UtilityService.isUndefinedOrNull(responseObj['25_completions_rate'])
				? parseFloat(responseObj['25_completions_rate']) >= 100
					? '100'
					: parseFloat(responseObj['25_completions_rate']).toFixed(2)
				: 0;
			platformNetwork.value25 = !UtilityService.isUndefinedOrNull(responseObj['25_percent'])
				? parseInt(responseObj['25_percent'], 10)
				: 0;
			platformNetwork.percent50 = !UtilityService.isUndefinedOrNull(responseObj['50_completions_rate'])
				? parseFloat(responseObj['50_completions_rate']) >= 100
					? '100'
					: parseFloat(responseObj['50_completions_rate']).toFixed(2)
				: 0;
			platformNetwork.value50 = !UtilityService.isUndefinedOrNull(responseObj['50_percent'])
				? parseInt(responseObj['50_percent'], 10)
				: 0;
			platformNetwork.percent75 = !UtilityService.isUndefinedOrNull(responseObj['75_completions_rate'])
				? parseFloat(responseObj['75_completions_rate']) >= 100
					? '100'
					: parseFloat(responseObj['75_completions_rate']).toFixed(2)
				: 0;
			platformNetwork.value75 = !UtilityService.isUndefinedOrNull(responseObj['75_percent'])
				? parseInt(responseObj['75_percent'], 10)
				: 0;
			platformNetwork.percent100 = !UtilityService.isUndefinedOrNull(responseObj['100_completions_rate'])
				? parseFloat(responseObj['100_completions_rate']) >= 100
					? '100'
					: parseFloat(responseObj['100_completions_rate']).toFixed(2)
				: 0;
			platformNetwork.value100 = !UtilityService.isUndefinedOrNull(responseObj['100_percent'])
				? parseInt(responseObj['100_percent'], 10)
				: 0;
			platformNetworks.push(platformNetwork);
		}
		return platformNetworks;
	}
}
